(function () {
  'use strict';

  (function () {
    new themegoal.helpers.Responsive();
    new TG_ProductCardColorSwatch();
    const setElementHeightVar = (element, varName) => {
      const value = element ? `${element.offsetHeight}px` : '0px';
      document.documentElement.style.setProperty(varName, value);
    };
    const headerSection = document.getElementById('Header');
    const announcementBarSection = document.getElementById('AnnouncementBar');
    const pageHeader = document.getElementById('PageHeader');
    const updateLayoutVars = () => {
      setElementHeightVar(headerSection, '--tg-header-height');
      setElementHeightVar(announcementBarSection, '--tg-announcement-bar-height');
      setElementHeightVar(pageHeader, '--tg-page-header-height');
    };
    updateLayoutVars();
    if (document.fonts?.ready) {
      document.fonts.ready.then(updateLayoutVars);
    }
    if ('ResizeObserver' in window) {
      const resizeObserver = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === headerSection) {
            setElementHeightVar(headerSection, '--tg-header-height');
          } else if (entry.target === announcementBarSection) {
            setElementHeightVar(announcementBarSection, '--tg-announcement-bar-height');
          } else if (entry.target === pageHeader) {
            setElementHeightVar(pageHeader, '--tg-page-header-height');
          }
        });
      });
      if (headerSection) {
        resizeObserver.observe(headerSection);
      }
      if (announcementBarSection) {
        resizeObserver.observe(announcementBarSection);
      }
      if (pageHeader) {
        resizeObserver.observe(pageHeader);
      }
    }
    let windowWidth = window.innerWidth;
    window.addEventListener('resize', function () {
      let newWidth = window.innerWidth;

      if (newWidth === windowWidth) {
        return;
      }

      windowWidth = newWidth;
      document.documentElement.style.setProperty('--tg-window-height', window.innerHeight + 'px');
      updateLayoutVars();
    });
    if (document.getElementById('SearchDrawer')) new TG_SearchDrawer();
  })();

  (function () {
    const drawerElement = document.getElementById('FilterProductsDrawer');

    if (!drawerElement) {
      return;
    }

    const bodyElement = document.body;
    const mobileQuery = window.matchMedia('(max-width: 749px)');

    const syncHeaderVisibility = () => {
      const shouldHideHeader = drawerElement.classList.contains('Show') && mobileQuery.matches;
      bodyElement.classList.toggle('FilterDrawerActive', shouldHideHeader);
    };

    drawerElement.addEventListener('shown.tg.Drawer', syncHeaderVisibility);
    drawerElement.addEventListener('hidden.tg.Drawer', syncHeaderVisibility);
    mobileQuery.addEventListener('change', syncHeaderVisibility);

    syncHeaderVisibility();
  })();

  (function () {
    var BANNER_ID = 'shopify-pc__banner';
    var ACTIVE_CLASS = 'cookie-banner-active';
    var bannerObserver;
    var bodyObserver;

    function isBannerVisible(banner) {
      if (!banner) {
        return false;
      }

      var style = window.getComputedStyle(banner);

      return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
    }

    function updateBodyState(banner) {
      var active = isBannerVisible(banner);
      document.body.classList.toggle(ACTIVE_CLASS, active);
    }

    function watchBanner(banner) {
      if (bannerObserver) {
        bannerObserver.disconnect();
        bannerObserver = null;
      }

      if (!banner) {
        updateBodyState(null);
        return;
      }

      bannerObserver = new MutationObserver(function () {
        updateBodyState(banner);
      });

      bannerObserver.observe(banner, {
        attributes: true,
        attributeFilter: ['style', 'class', 'hidden', 'aria-hidden'],
      });

      updateBodyState(banner);
    }

    function findBanner() {
      var banner = document.getElementById(BANNER_ID);
      watchBanner(banner);
    }

    function startObservers() {
      findBanner();

      if (bodyObserver) {
        return;
      }

      bodyObserver = new MutationObserver(findBanner);
      bodyObserver.observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', startObservers);
    } else {
      startObservers();
    }
  })();

})();
